import React, { forwardRef } from 'react'

import TextField, { TextFieldProps } from '@mui/material/TextField'

export const CommonTextField: React.FC<TextFieldProps> = forwardRef((props, ref) => (
  <TextField
    ref={ref}
    variant="standard"
    margin="normal"
    size="small"
    required={false}
    fullWidth
    FormHelperTextProps={{
      style: {
        fontWeight: 'bold',
        fontSize: '12px',
      },
    }}
    {...props}
  />
))

CommonTextField.displayName = 'CommonTextField'
